export const getFullName = ({
  firstName,
  lastName
}: {
  firstName: string
  lastName: string
}) => `${lastName} ${firstName}`
